import { httpRequest } from "@services/http";
import { Contract } from "@models/contract.model";
import { ContractSerializer } from "@models/serializers/contractSerializer";

export class CommandGetAvailableContracts {
  async run(engagementId: number): Promise<Contract[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/contract/available/`;

    try {
      const response = await httpRequest<{ contracts: any[] }>(url, { method: "GET" });
      return ContractSerializer.fromJsonList(response.contracts);
    } catch (error) {
      console.error(`Error fetching available contracts for engagement ${engagementId}:`, error);
      throw error;
    }
  }
}